// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ls-button__wrapper[data-v-08477640]{align-content:center;display:flex;flex-direction:row;flex-wrap:wrap;gap:24px;justify-content:flex-end;margin-top:24px}@media(max-width:576px){.ls-button__wrapper[data-v-08477640]{flex-direction:column;justify-content:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
